// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import AuthModelInvite from './AuthModelInvite';

import { IRoute } from '../';

const Routes: IRoute[] = [
    {
        crumbText: 'Auth Change Invitation',
        component: AuthModelInvite,
        exact: true,
        path: '/authModelInvite',
    },
];

export default Routes;